import React from "react";
import { Layout } from "./components/Layout";
import "./css/styles.scss";

function App() {
  return <Layout />;
}

export default App;
